const routes = [
  {
    path: "/purchased-addons",
    name: "PurchasedAddOns",
    component: () => import(/* webpackChunkName: "AppInfo" */ "../addonsPurchased/views/PurchasedAddOns/PurchasedAddOns.vue"),
  },
  {
    path: "/paygateproxy",
    name: "paygateproxy",
    component: () => import(/* webpackChunkName: "Purchase" */ "./views/paygateproxy/paygateproxy.vue"),
    props: route => {
      const res = Object.assign({}, route.query, route.params)
      try {
        res.cart_items = JSON.parse(res.cart_items)
      } catch (e) {
        res.cart_items = []
      }
      try {
        res.cartItemsToPurchase = JSON.parse(res.cartItemsToPurchase)
      } catch (e) {
        res.cartItemsToPurchase = []
      }
      return res
    },

  },
];
export default routes;
